import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiShopService } from '../../../../services/shop/api/api-shop.service';
import { AlertsService } from '../../../../services/alerts.service';
import { ShopItemReward } from '../../../../models/shop/shop-item-reward.model';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';

@Component({
  selector: 'app-shop-item-add-modal',
  templateUrl: './shop-item-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class ShopItemAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  name: string = '';
  iapId: string = '';
  price: number = 0;
  isPack: boolean = false;
  rewards: ShopItemReward[] = [];
  readonly UserCurrencyType = UserCurrencyType;
  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiShopService: ApiShopService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.name = '';
    this.iapId = '';
    this.price = 0;
    this.isPack = false;
    this.rewards = [];
    this.isLoading = false;
    this.modal.show();
  }

  addReward(): void {
    const r = new ShopItemReward();
    this.rewards.push(r);
  }

  removeReward(index: number): void {
    this.rewards.splice(index, 1);
  }

  save(): void {
    this.isLoading = true;
    this.apiShopService.addItem(this.name, this.iapId, this.price, this.isPack, this.rewards).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Item added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding item : ' + error);
      }
    );
  }
}
